import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import {
  Experience,
  UserExperience,
  UserExperienceBase,
} from 'src/app/shared/model/user-experince';
import { ApiResponse } from '../api-response.model';

@Injectable({
  providedIn: 'root',
})
export class UserExperienceService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: ApiConfiguration) {
    this.baseUrl = `${this.config.rootUrl}/usuario-experiencia`;
  }

  createExperience(
    payload: UserExperienceBase
  ): Observable<ApiResponse<Experience>> {
    return this.http.post<ApiResponse<Experience>>(this.baseUrl, payload);
  }

  updateExperience(
    id: string,
    payload: UserExperienceBase
  ): Observable<ApiResponse<UserExperience>> {
    return this.http.patch<ApiResponse<UserExperience>>(
      `${this.baseUrl}/${id}`,
      payload
    );
  }

  deleteExperience(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.baseUrl}/${id}`);
  }

  getExperiencesByUser(
    idUser: string
  ): Observable<ApiResponse<{ experiences: UserExperienceResponse[] }>> {
    return this.http.get<
      ApiResponse<{ experiences: UserExperienceResponse[] }>
    >(`${this.baseUrl}/obtener-por-usuario/${idUser}`);
  }

  getExperienceById(id: string): Observable<ApiResponse<UserExperience>> {
    return this.http.get<ApiResponse<UserExperience>>(
      `${this.baseUrl}/obtener-por-id/${id}`
    );
  }
}
